export default __webpack_public_path__ + "static/media/alpha-right.055e0aa9.svg";